<template>
    <path d="M7.5 19V13H17.5V19H19.5V7.828L16.672 5H5.5V19H7.5ZM4.5 3H17.5L21.5 7V20C21.5 20.2652 21.3946 20.5196 21.2071 20.7071C21.0196 20.8946 20.7652 21 20.5 21H4.5C4.23478 21 3.98043 20.8946 3.79289 20.7071C3.60536 20.5196 3.5 20.2652 3.5 20V4C3.5 3.73478 3.60536 3.48043 3.79289 3.29289C3.98043 3.10536 4.23478 3 4.5 3ZM9.5 15V19H15.5V15H9.5Z" fill="white"></path>
</template>

<script>
    export default {
        name: 'icon-save'
    }
</script>